<template>
  <div class="loading-container">
    <div v-if="!errorText" class="spinner"></div>
    <div class="loading-text">{{ errorText || "加载中..." }}</div>
  </div>
</template>

<script>
import {
  setToken,
  setRefreshToken,
  removeToken,
  removeRefreshToken,
} from "@saas/service-api/src/plugins/auth";

export default {
  name: "mini-redirect",
  data() {
    return {
      errorText: "",
    };
  },
  created() {
    const params = new URLSearchParams(window.location.search);
    const path = params.get("path");
    const accessToken = params.get("accessToken");
    const refreshToken = params.get("refreshToken");

    if (!path || !path.startsWith("/")) {
      this.errorText = "页面地址无效，请返回小程序重试";
      return;
    }

    if (accessToken) {
      setToken(accessToken);
      if (refreshToken) {
        setRefreshToken(refreshToken);
      } else {
        // Never pair a new access token with a previous account's refresh token.
        removeRefreshToken();
      }
    } else if (params.has("accessToken")) {
      // An explicit anonymous session must not reuse an older H5 account.
      removeToken();
      removeRefreshToken();
    }

    Promise.resolve(this.$router.replace({ path })).catch(() => {
      this.errorText = "页面加载失败，请返回小程序重试";
    });
  },
};
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--page-bg);
}

.spinner {
  border: 2px solid var(--border-subtle);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-left-color: var(--text-primary);
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  margin-top: 10px;
  font-size: 14px;
  color: var(--text-primary);
}
</style>
